import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import Organizations from "@/pages/Organizations";
import NewAssessment from "@/pages/NewAssessment";
import DataEntry from "@/pages/DataEntry";
import Results from "@/pages/Results";
import Materiality from "@/pages/Materiality";
import Disclosure from "@/pages/Disclosure";
import UsersPage from "@/pages/Users";
import SettingsPage from "@/pages/Settings";
import Trend from "@/pages/Trend";
import Documents from "@/pages/Documents";
import ChangePassword from "@/pages/ChangePassword";
import PublicRegistry from "@/pages/PublicRegistry";
import PublicCertificate from "@/pages/PublicCertificate";
import SecurityPage from "@/pages/Security";
import { INTERNAL_ROLES } from "@/lib/roles";

const READERS = [...INTERNAL_ROLES, "partner"];

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/home" element={<Landing />} />
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          {/* Public registry — no auth required */}
          <Route path="/registro" element={<PublicRegistry />} />
          <Route path="/registro/:code" element={<PublicCertificate />} />
          <Route path="/verifica/:code" element={<PublicCertificate />} />
          <Route path="/cambio-password" element={
            <ProtectedRoute><ChangePassword /></ProtectedRoute>
          } />
          <Route
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route path="/app" element={<Dashboard />} />
            <Route path="/aziende" element={<ProtectedRoute roles={READERS}><Organizations /></ProtectedRoute>} />
            <Route path="/aziende/:id/trend" element={<ProtectedRoute roles={READERS}><Trend /></ProtectedRoute>} />
            <Route path="/documenti" element={<Documents />} />
            <Route path="/sicurezza" element={<SecurityPage />} />
            <Route path="/assessment/nuovo" element={<ProtectedRoute roles={["admin", "valuatore"]}><NewAssessment /></ProtectedRoute>} />
            <Route path="/assessment/:id/compila" element={<ProtectedRoute roles={[...READERS, "cliente"]}><DataEntry /></ProtectedRoute>} />
            <Route path="/assessment/:id/materialita" element={<ProtectedRoute roles={READERS}><Materiality /></ProtectedRoute>} />
            <Route path="/assessment/:id/disclosure" element={<ProtectedRoute roles={READERS}><Disclosure /></ProtectedRoute>} />
            <Route path="/assessment/:id/risultati" element={<ProtectedRoute roles={READERS}><Results /></ProtectedRoute>} />
            <Route path="/utenti" element={<ProtectedRoute roles={["admin"]}><UsersPage /></ProtectedRoute>} />
            <Route path="/impostazioni" element={<ProtectedRoute roles={["admin", "resp_metodologia"]}><SettingsPage /></ProtectedRoute>} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </AuthProvider>
  );
}
